import { vsosHttp as http } from 'lib/services/http';

/**
 * VSOS Swagger for Hunt Groups Voicemail available at
 * http://10.103.50.156:8080/swagger-ui.html#/Hunt-Groups/Voicemail
 */

const deleteHuntGroupVoicemailGreeting = (
  groupId: string,
  greetingName: string,
) => {
  return http.delete(
    `/hunt-groups/${groupId}/voicemail/greeting/${greetingName}`,
  );
};

const getHuntGroupVoicemailAdvanced = (groupId: string) => {
  return http.get(`/hunt-groups/${groupId}/voicemail/advanced-settings`);
};

const getHuntGroupVoicemailOptions = (groupId: string) => {
  return http.get(`/hunt-groups/${groupId}/voicemail/options`);
};

const postHuntGroupVoicemailGreeting = (
  groupId: string,
  greetingName: string,
  formData: File,
  updateDefaultGreeting = true,
) => {
  return http.post(
    `/hunt-groups/${groupId}/voicemail/greeting/${greetingName}`,
    formData,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
        'X-Requested-With': 'XMLHttpRequest',
      },
      params: {
        updateDefaultGreeting,
      },
    },
  );
};

const putHuntGroupVoicemailAdvanced = (groupId: string, requestBody) => {
  return http.put(
    `/hunt-groups/${groupId}/voicemail/advanced-settings`,
    requestBody,
  );
};

const putHuntGroupVoicemailGreeting = (groupId: string, requestBody) => {
  return http.put(`/hunt-groups/${groupId}/voicemail/greeting`, requestBody);
};

const putHuntGroupVoicemailOptions = (groupId: string, requestBody) => {
  return http.put(`/hunt-groups/${groupId}/voicemail/options`, requestBody);
};

const putHuntGroupVoicemailStatus = (groupId: string, requestBody) => {
  return http.put(`/hunt-groups/${groupId}/voicemail/status`, requestBody);
};

export default {
  deleteHuntGroupVoicemailGreeting,
  getHuntGroupVoicemailAdvanced,
  getHuntGroupVoicemailOptions,
  postHuntGroupVoicemailGreeting,
  putHuntGroupVoicemailAdvanced,
  putHuntGroupVoicemailGreeting,
  putHuntGroupVoicemailOptions,
  putHuntGroupVoicemailStatus,
};
